import { render, staticRenderFns } from "./tzltgz.vue?vue&type=template&id=07bc9b8e&scoped=true&"
import script from "./tzltgz.vue?vue&type=script&lang=js&"
export * from "./tzltgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc9b8e",
  null
  
)

export default component.exports